/**
 * 「我的」Tab 懒加载壳（21k 轮补；StickerPacksLazy 同构）。
 *
 * 首屏默认落 chats Tab，me Tab 只有用户点过去才需要——按 PROMPT「非首屏功能
 * 一律动态 import」拆出去。它还会连带拖走 ConfirmDialog / myProfilePageModel /
 * 一堆 nav actions，是首屏瘦身性价比最高的一刀。
 */
import { useLazyModule } from './useLazyModule';
import { MeTabSkeleton } from '~/ui/Skeleton';

export function MeTabLazy() {
  const { mod } = useLazyModule(() => import('./MeTab'));
  // 21w：此前是一行居中的「加载中…」，块一到整页换掉 → 闪一下再跳版。
  // 骨架按真实版式占位，块到了只是灰块换成内容。
  if (mod === null) return <MeTabSkeleton />;
  return <mod.MeTab />;
}
